import React from "react";
import { observer } from "mobx-react-lite";
import { View, TouchableOpacity, Modal } from "react-native";

import SideMenu from "./SideMenu";

const CustomDrawerModal = observer(
  ({ coach, requestProfileLeaveAwareNavigation = null }) => {
    return (
    <Modal
      transparent={true}
      animationType="none"
      visible={coach.sideMenuVisible}
    >
      <View
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 220,
          backgroundColor: "#1E1E1E",
          flex: 1,
          minHeight: 500,
        }}
      >
        <SideMenu
          coach={coach}
          requestProfileLeaveAwareNavigation={requestProfileLeaveAwareNavigation}
        />
      </View>
      <TouchableOpacity
        onPress={() => coach.setProperty("sideMenuVisible", false)}
        style={{
          position: "absolute",
          top: 0,
          left: 220,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(15, 15, 15, 0.2)",
        }}
      />
    </Modal>
    );
  }
);

export default CustomDrawerModal;
